import React, { createRef } from "react";

// @material-ui/icons
import { CircularProgress, FormControlLabel, RadioGroup, TextField, Radio } from '@mui/material';
import DataTable from "components/Table/DataTable";
// core components
import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import Tooltip from "@mui/material/Tooltip";
import MDTypography from "components/MDTypography";
import { ExternalLink } from "react-external-link";
import { Box } from '@mui/material';
import axios from "axios";
import { queryClient } from "index.js";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";
import Button from "components/CustomButtons/Button.js";
import MDBox from "components/MDBox";
import PrettyBytes from "react-pretty-bytes";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import LinearProgress from '@mui/material/LinearProgress';
import InputAdornment from '@mui/material/InputAdornment';
import { getApiCall } from "hooks/axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";
import { toast } from "react-toastify";
import AppDialog from "components/Dialog/AppDialog";



export default function SystemLogs(props) {
  let url = "/api/v1/logsmetrics";
  const deleteUrl = "/api/v1/logsmetrics";
  const downloadUrl = "/api/v1/logsmetrics/download";
  const retentionUrl = "/api/v1/logsmetrics/retention";
  const [token, setToken] = useToken();
  const [open, setOpen] = React.useState(true);
  const [catchUpLoad, setCatchUpLoad] = React.useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isCreatingArchive, setIsCreatingArchive] = useState(false);
  const [disabledUpdateBtn, setDisabledUpdateBtn] = useState(false);
  const [logsData, setLogsData] = React.useState(['app_metrics', 'app_logs', 'system_logs', 'iq_report']);
  const [retentionResultData, setRetentionResultData] = useState();
  const [baseUrl, setBaseUrl] = useState("");
  const [dateFromInputValue, setDateFromInputValue] = useState(moment().subtract(1,'d'));
  const [dateToInputValue, setDateToInputValue] = useState(moment());
  const [disableDateField, setdisableDateField] = useState(true);
  const [rangeType, setRangeType] = useState("all");
  const [dialogData, setdialogData] = useState({
    title: "",
    text: "",
    isOpen: false,
    onYes: null,
    onNo: null,
  });
  const [retentionDuration, setRetentionDuration] = useState(0);

  const showDialog = (title, text, onYes) => {
    setdialogData({
      title: title,
      text: text,
      isOpen: true,
      onYes: function() {
        const data = dialogData;
        data.isOpen = false;
        setdialogData(data);
        onYes.call();
      },
      onNo: function() {
        const data = dialogData;
        data.isOpen = false;
        setdialogData(data);
      }
    });
  }

  useAxiosAuth(token);
  const tok = localStorage.getItem('token');
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 235,
  };

  const retentionResult = useQuery({
    queryKey: ["retention"],
    queryFn: async () => await getApiCall(retentionUrl, {
      onError: function(error) {
        handleArchiveMsg("error", error.message);
      }
    }),
    onError(error) {
      handleArchiveMsg("error", error.message);
    },
    onSuccess(data) {
      if(data.hasOwnProperty("retention")) {
        setRetentionDuration(Number(data.retention));
      }
    }
  });

  useEffect(() => {
    setRetentionResultData(retentionResult.data);
  }, [retentionResult.data])
  
  const getBaseUrl = async () => {
    try {
      const data = await getApiCall("/api/v1/baseurl", {
        onError: function(error){
          handleArchiveMsg("error", error.message)
        }
      });

      const { base_url } = data;

      return base_url;

    } catch (err) {
      handleArchiveMsg("error", "Error: failed to get BE base url");
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const baseUrl = await getBaseUrl();

      setBaseUrl(baseUrl);
    };

    fetchData();
  }, []);
  
  const names = [
    { key: "Application Metrics", value: 'app_metrics' },
    { key: "Application Logs", value: 'app_logs' },
    { key: "System Journal", value: 'system_logs' },
    { key: "IQ report", value: 'iq_report' },
  ];

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setLogsData(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleOnCreateLog = () => {
    if (logsData.length) {
      createLogsMetrics();
    }
  };

  const DeleteButton = ({ name }) => (
    <MDTypography
      component={ExternalLink}
      href="#"
      variant="body2"
      color="info"
      onClick={(e) => {
        e.preventDefault();
        showDialog("Delete Archive",
          "Deleting an archive will free up space on the Ardia server. Do you want to proceed?",
          function() {
            handleDelete(e, name);
          }
        );
      }}
    >
      <Tooltip title="Delete" placement="top">
        <DeleteIcon fontSize="medium" />
      </Tooltip>
    </MDTypography>
  );

  
  function tableSort(a, b, desc) {
    if (Number.isNaN(a)) {  // Blanks and non-numeric strings to bottom
      a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (Number.isNaN(b)) {
        b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }

    if (a > b) return 1; 
    if (a < b) return -1;
    return 0;
  }

  const sortBySize = (rowA, rowB, id, desc) => {
    let a = Number.parseInt((rowA.values[id].hasOwnProperty("props")) ? rowA.values[id].props.bytes : '');
    let b = Number.parseInt((rowB.values[id].hasOwnProperty("props")) ? rowB.values[id].props.bytes : '');
    return tableSort(a, b, desc);
  }

  const sortByDate = (rowA, rowB, id, desc) => {
    // format as Date('..')toLocaleString('en-GB')
    let a = moment(rowA.values[id], "DD/MM/YYYY, hh:mm:ss").unix();
    let b = moment(rowB.values[id], "DD/MM/YYYY, hh:mm:ss").unix();
    return tableSort(a, b, desc);
  }

  const columns = [
    {
      Header: "Name",
      accessor: "name",
      width: "10%",
      align: "left",
      isSorted: true,
    },
    {
      Header: "Created",
      accessor: "created",
      width: "20%",
      align: "left",
      sortType: sortByDate,
    },
    { 
      Header: "Size",
      accessor: "size",
      width: "10%", 
      align: "center",
      sortType: sortBySize,
    },
    { 
      Header: "Download",
      accessor: "download",
      width: "15%",
      align: "center"
    },
    { 
      Header: "Delete",
      accessor: "delete",
      width: "15%",
      align: "center"
    }
  ];


  const refetchValue = 10000;
  const enableApi = true;
  const { isLoading, error, data } = useQuery({
    queryKey: ["compressedArchive"],
    queryFn: async () => await getApiCall(url, {
      onError: function(error) {
        handleArchiveMsg("error", error.message);
      }
    }),
    onError(error) {
      handleArchiveMsg("error", error.message);
    },
    refetchInterval: refetchValue,
  });

  const logsmetricsStatus = useQuery({
    queryKey: ["logsmetricsStatus"],
    queryFn: async () => await getApiCall(`${url}/job`, {
      onError: function(error) {
        handleArchiveMsg("error", error.message);
      }
    }),
    onError(error) {
      handleArchiveMsg("error", error.message);
    },
    onSuccess(data) {
      if (data && data.hasOwnProperty("running") && !data.running && isCreatingArchive) {
        setIsCreatingArchive(false);
      }
    },
    refetchInterval: refetchValue,
  });

  const createLogsMetrics = async () => {
    setIsCreatingArchive(true);
    handleArchiveResponse(true, true);
    handleArchiveMsg("info", "Creating archive!");
    await createLogArchive();
  };

  const handleArchiveResponse = (logsCreation, setopen) => {
    setIsCreatingArchive(logsCreation);
    setOpen(setopen);
  };
  const handleArchiveMsg = (severity, msg) => {
    switch(severity) {
      case "warning":
        toast.warning(msg);
        break;
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "info":
        toast.info(msg);
        break;
      default:
        toast.error(msg);
    }
  };
  
  const getLogsRangeDate = () => {
    if (rangeType === "all") {
      // minimum retention policy 7 days
      const retention = (retentionResultData && retentionResultData.retention)? retentionResultData.retention : 7;
      const toUtcDate = moment().utc();
      const fromUtcDate = moment().subtract(retention,"d");
  
      return {
        date_from: fromUtcDate.format("YYYYMMDD"),
        date_to: toUtcDate.format("YYYYMMDD"),
        error: false
      };
    } else {
      // handle error from input
      if (dateFromInputValue.toDate().getTime() > dateToInputValue.toDate().getTime()) {
        handleArchiveMsg("error", "Date to must be greater then date from");
        setIsCreatingArchive(false);
        return {
          error: true
        };
      }
      return {
        date_from: dateFromInputValue.utc().format("YYYYMMDD"),
        date_to: dateToInputValue.utc().format("YYYYMMDD"),
        error: false
      };
    }
    
  }
  const createLogArchive = async () => {
    let body = {};
    for (let i of logsData) {
      body[i] = true;
    }
    const {date_from, date_to, error} = getLogsRangeDate();
    
    if (!error) {
      body.date_from = date_from;
      body.date_to = date_to;
      
      await axios
        .post(
          url,
          body,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json", 
            },
            validateStatus: () => true
          }
        )
        .then(function (response) {
          setLogsData(['app_metrics', 'app_logs', 'system_logs','iq_report']);
          if (response.status == 204) {
            handleArchiveMsg("success", "Archive job started sucessfully!");
          } else if (response.status == 404) {
            handleErrorResponse(response);
          } else {
            handleArchiveMsg("error", "Error in creating archive");
          }
          queryClient.invalidateQueries("compressedArchive");
          return response;
        })
        .catch(function (error) {
          handleArchiveResponse(false, true);
          queryClient.invalidateQueries("compressedArchive");
          handleArchiveMsg("error", "Error in creating archive");
        });
    }
  
  };

  const handleErrorResponse = (response) =>{
    if (response.hasOwnProperty("data") && response.data.hasOwnProperty('errors') && Array.isArray(response.data.errors)) {
      response.data.errors.array.forEach(error => {
        handleArchiveMsg(
          "error",
          error.message
        );
      });
    }
  }
  const handleDelete = async (event, name) => {
    event.preventDefault();
    try {
      const deleteResp = await axios
        .delete(deleteUrl + "/" + name, {}, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true
        })
        .then(function (response) {
          handleArchiveResponse(false, true);
          if (response && response.status == 204) {
            handleArchiveMsg(
              "success",
              "Archive " + name + " was successfully deleted "
            );
          } else if (response.status == 403) {
            handleErrorResponse(response);
          } else {
            handleArchiveMsg("error", "Error when deleting archive!");
          }
          queryClient.invalidateQueries("compressedArchive");
          return response;
        })
        .catch(function (error) {
          handleArchiveResponse(false, true);
          queryClient.invalidateQueries("compressedArchive");
          handleArchiveMsg("error", "Error when deleting archive!");
        });
    } catch (e) {
      setMessage("Error while deleting" + fileName);
      setIsError(true);
    }
    queryClient.invalidateQueries("compressedArchive");
  };


 function  handleOnChangeRetentionInput(data) {
    const inputData = parseInt(data);
    /// allow only integer greater then 1
    if (Number.isInteger(inputData)) {
      if (inputData > 60 || inputData < 1) {
        setDisabledUpdateBtn(true);
        handleArchiveMsg("error", "Minimal valid retention is 1 (day), maximum 60 days");
      } else {
        setDisabledUpdateBtn(false);
        
      }
      return { retention: Number(inputData) };
    } else {
      setDisabledUpdateBtn(true);
      return { retention: '' };
    }
  }

  const updateRetentionApiCall = async () => {
    await axios
      .post(
        retentionUrl,
        retentionResultData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true
        }
      )
      .then(function (response) {
        handleArchiveResponse(false, true);
        if (response.status == 204) {
          setRetentionDuration(Number(retentionResultData.retention));
          setDisabledUpdateBtn(false);
          handleArchiveMsg("success", "Retention Policy updated sucessfully!");
        } else if (response.status == 403) {
          setDisabledUpdateBtn(false);
          handleErrorResponse(response)
        } else {
          setDisabledUpdateBtn(false);
          handleArchiveMsg("error", "Error in updating retention Policy");
        }
        queryClient.invalidateQueries("updateRententionPolicy");
        return response;
      })
      .catch(function (error) {
        setDisabledUpdateBtn(false);
        handleArchiveResponse(false, true);
        queryClient.invalidateQueries("updateRententionPolicy");
        handleArchiveMsg("error", "Error in updating retention Policy");
      });
  }

  const updateRetentionPolicy = async (event) => {
    event.preventDefault();
    /// we check already input, we dont need else statment
    if (retentionResultData.hasOwnProperty("retention") && Number.isInteger(retentionResultData.retention)) {
      if(retentionResultData.retention < retentionDuration) {
        showDialog("Retention Policy", 
          "Are you sure you want to decrease Ardia system logs and metrics retention policy? All existing logs and metrics exceeding new retention policy will be permanently removed",
          function(){
            setDisabledUpdateBtn(true);
            updateRetentionApiCall();
          }
        );
      } else {
        updateRetentionApiCall();
      }
    }
  }

  const cancelArchieve = async (e) => {
    e.preventDefault();
    try {
      await axios
        .delete(url + "/job", {}, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          validateStatus: () => true
        })
        .then(function (response) {
          handleArchiveResponse(false, true);
          if (response && response.status == 200) {
            handleArchiveMsg(
              "success",
              "Cancelled the running collection job"
            );
          } else if (response.status == 403) {
            handleErrorResponse(response);
            
          } else {
            handleArchiveMsg("error", "Error when cancelling the job!");
          }
          return response;
        })
        .catch(function (error) {
          handleArchiveResponse(false, true);
          handleArchiveMsg("error", "Error when cancelling the job!");
        });
    } catch (e) {
      setMessage("Error while cancelling the job");
      setIsError(true);
    }
  }

  const archivesData = (data) => {
    let tableData = {
      columns: columns,
      rows: [],
    };
    
    if (data && data.hasOwnProperty("items") && data.items && data.items.length > 0) {  
      tableData.rows = data.items.map((item) => {
        return {
          name: item.name,
          size: (Number.isInteger(item.size)) ? <PrettyBytes bytes={item.size} /> : "",
          created: new Date(item.created).toLocaleString('en-GB'),
          delete: item.name ? (
            <DeleteButton name={item.name.replace("/", "")} />
          ) : (
            ""
          ),
          download:
            <a href={`${baseUrl}${downloadUrl}/${item.name.replace("/", "")}?access_token=${JSON.parse(tok)}`}>
              <Tooltip title="Download" placement="top">
                <ArrowDownwardIcon fontSize="medium" />
              </Tooltip>
            </a>
        };
      });
    }

    return tableData;
  };

  const onChangeRangeType = (event) => {
    if (event.target.value === 'all') {
      setdisableDateField(true);

    } else {
      
      setdisableDateField(false);
    }
    setRangeType(event.target.value);
  };

  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box minWidth={35}>
          <MDTypography variant="body2" color="textSecondary">{`${Math.round(
            props.value
          )}%`}</MDTypography>
        </Box>
      </Box>
    );
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          marginBottom: "20px",
          margin: "0 -5px",
        }}
      >
        <div style={{ flex: 3, margin: "0 5px", backgroundColor: "#ffffff" }}>
          <div style={{display: "flex", flexDirection: "row", margin: "0 -10px", padding: "24px"}}>
            <FormControl sx={{ m: 1, width: 250, margin: "0 10px" }}>
              {logsmetricsStatus.data != undefined && logsmetricsStatus.data.progress > 0 ?
                (<>
                  <Button onClick={(e) => {
                    cancelArchieve(e)
                  }} color="grey" >
                    Cancel
                  </Button>
                  <div>
                    <LinearProgressWithLabel
                      value={logsmetricsStatus.data != undefined && logsmetricsStatus.data.progress}
                    />
                  </div>
                </>)
                :
                (<>
                  <div style={{ display: "flex", width: "100%" }}>
                    <Button
                      sx={{
                        width: "80%", height: "50px", margin: "0% 1% 0% 0% !important", background: "red !important", "&.Mui-disabled": { background: "#eaeaea" }
                      }}
                      size="medium"
                      color="primary"
                      onClick={handleOnCreateLog}
                      disabled={isCreatingArchive || (logsmetricsStatus.data != undefined && logsmetricsStatus.data.progress > 0)}
                    >
                      Create Archive &nbsp;
                    </Button>
                    <Select
                      sx={{
                        background: 'red', borderRadius: 1.5, width: "20%", height: "50px",
                        "& .MuiSvgIcon-root": { color: '#fff', top: '8%', height: '3em', width: '3em', left: '8%' },
                        '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' },
                        "& .Mui-disabled": { background: "#9d9da1", color: "#ffffff", opacity: "0.5" },
                        '&:hover': {
                          boxShadow: '0 14px 26px -12px rgba(0, 118, 216, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 118, 216, 0.2)',
                        },
                      }}
                    multiple
                    value={logsData}
                    onChange={handleChange}
                    renderValue={(selected) => <span></span>}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                      },
                      getContentAnchorEl: null,
                    }}
                    variant="outlined"
                    >
                    {names.map((name) => (
                      <MenuItem key={name.key} value={name.value} style={MenuProps} sx={{ '& .MuiMenuItem-root , &.Mui-selected:focus , &.Mui-selected, &.Mui-selected:hover ': { background: 'none' }, '& .MuiTypography-root': { fontSize: '1rem', color: '#333' } }}>
                        <Checkbox checked={logsData.indexOf(name.value) > -1} />
                        <ListItemText primary={name.key} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
            </>)
              }
          
          </FormControl>
          <div style={{margin: "0 10px"}}>
            <Box><b>Set Range for Logs and Metrics:</b></Box>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="all"
              name="radio-buttons-group" onChange={onChangeRangeType}
            >
              <FormControlLabel value="all" control={<Radio />} label="Entire retention period" />
              <FormControlLabel value="custom" control={<Radio />} label="Select period" />
            </RadioGroup>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <div style={{display:"flex", flexDirection: "row", flexWrap: "nowrap",}}> 
                <DatePicker 
                  label="From" 
                  disabled={disableDateField} 
                  maxDate={moment()} 
                  defaultValue={dateFromInputValue}
                  onChange={(value) => {setDateFromInputValue(value)}}
                />
                <div style={{width: "10px"}}></div>
                <DatePicker
                  label="To"
                  disabled={disableDateField}
                  maxDate={moment()}
                  defaultValue={dateToInputValue} 
                  onChange={(value) => {setDateToInputValue(value)}}
                />
              </div>
            </LocalizationProvider>
          </div>
        </div>
      </div>
      
      <div style={{ width: "100%", color: "red", flex: 2, margin: "0 5px", backgroundColor: "#ffffff"  }}>
        <MDBox
          
          style={{
            padding: "23px 20px",
          }}
        >
          <Box><b>Retention Policy </b>   </Box>
          <div style={{ display: "flex", margin: "5px 0px 0px 0px", padding: "5px 0px", alignItems: "center" }}>
            {/* <Chip label="Application Metrics" /> */}
            <label>Duration:</label>
            {/* <Box><Chip label="Application Metrics" /> </Box> */}
            <TextField
              id="app-metrics"
              variant="standard"
              sx={{ background: "white", marginLeft: "10px", paddingLeft: "10px", width: "45%", height: "40px" }}
              inputProps={{
                sx: {
                  height: "40px !important",
                  padding: "0 !important"
                },
              }}
              InputProps={{
                endAdornment: <InputAdornment position="start"><span style={{ fontSize: "1rem" }}>days</span></InputAdornment>
              }}
              value={retentionResultData?.retention}
              onChange={(event) => {
                setRetentionResultData(prevState => {
                  return handleOnChangeRetentionInput(event.target.value);
                });
              }}
            />
          </div>
          <div style={{width:"100%", display: "flex", justifyContent: "center", paddingTop: "20px"}}>
            <Button onClick={(e) => {
              updateRetentionPolicy(e)
            }} color="primary" disabled={disabledUpdateBtn}>
              Update Policy
            </Button>
          </div>
        </MDBox>
      </div>
    </div>
      {
    isLoading && (
      <CircularProgress
        size={24}
        style={{ marginLeft: "45%", position: "relative", top: 4 }}
      />
    )
  }
      <AppDialog showDialog={dialogData}></AppDialog>
      <div style={{height: "10px"}}></div>
      <DataTable
        tableTitle="Compressed Archives"
        table={archivesData(data)}
        canSearch={true}
        showTotalEntries={true}
        isSorted={true}
        initialSortField="created"
        initialSortDesc={true}
        noEndBorder
        entriesPerPage={true}
      />
    </React.Fragment >
  );
}
